import { useEffect, useState } from 'react';

import { apiForms } from 'services/apiService';

export function useUserBioSummary(userId: string) {
  const [bio, setBio] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBio() {
      setLoading(true);
      try {
        // 1. Buscar todos os grupos/forms
        const groupsRes = await apiForms.get('/v1/groups/all');
        const groups = groupsRes.data;
        let foundForm = null;
        for (const group of groups) {
          foundForm = group.forms.find((f: any) => f.form_name === 'Biografia');
          if (foundForm) break;
        }
        if (!foundForm) {
          setBio(null);
          setLoading(false);
          return;
        }
        // 2. Buscar os campos do form
        const fieldsRes = await apiForms.get(`/v1/fields/${foundForm.id}`);
        const fields = fieldsRes.data;
        const targetField = fields.find(
          (field: any) => field.label === 'Conte-nos um pouco sobre sua TRAJETÓRIA profissional.'
        );
        if (!targetField) {
          setBio(null);
          setLoading(false);
          return;
        }
        // 3. Buscar submissão do usuário para esse campo
        const submissionsRes = await apiForms.get(
          `/v1/submissions/${targetField.id}?user_id=${userId}`
        );
        const submissions = submissionsRes.data;
        let value = null;
        if (submissions.length > 0 && submissions[0].values.length > 0) {
          value = submissions[0].values.map((v: any) => v.value).join(' ');
        }
        setBio(value);
      } catch (e) {
        setBio(null);
      } finally {
        setLoading(false);
      }
    }
    if (userId) fetchBio();
  }, [userId]);

  return { bio, loading };
}
